import {Injectable} from '@angular/core';
import {AbstractFindOneByIdService} from '../../../core/service/v2/service/findone/abstractFindOneById.service';
import {ExamFormDataServiceAdapter} from './ngrx/examFormDataService.adapter';
import {ExamFormRepository} from './ngrx/examForm.repository';
import {ExamFormModel} from '../../api/model/exam-form.model';

@Injectable()
export class ExamFormFindOneByIdService extends AbstractFindOneByIdService<ExamFormModel, ExamFormModel> {

    constructor(repository: ExamFormRepository, dataServiceAdapter: ExamFormDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}